type AnyFunction = (...args: any[]) => any;

export const throttle = <T extends AnyFunction>(func: T, wait: number): T => {
	let lastCallTime: number | null = null;
	let timeoutId: ReturnType<typeof setTimeout> | null = null;

	const throttledFunc = (...args: Parameters<T>): void => {
		const now = Date.now();

		if (lastCallTime === null || now - lastCallTime >= wait) {
			func(...args);
			lastCallTime = now;
		} else {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			const remainingTime = wait - (now - lastCallTime);
			timeoutId = setTimeout(() => {
				func(...args);
				lastCallTime = Date.now();
			}, remainingTime);
		}
	};

	return throttledFunc as T;
};

export const dateConverter = (isNewChat: boolean, dateString: string) => {
	if (isNewChat) return "";
	const inputDate = new Date(dateString);
	const currentDate = new Date();
	const differenceInMillis = currentDate.getTime() - inputDate.getTime();

	const differenceInMinutes = differenceInMillis / (1000 * 60);
	const differenceInHours = differenceInMillis / (1000 * 60 * 60);
	const differenceInDays = differenceInMillis / (1000 * 60 * 60 * 24);

	if (differenceInMinutes < 1) {
		return `now`;
	} else if (differenceInMinutes < 60) {
		return `${Math.round(differenceInMinutes)}m`;
	} else if (differenceInHours < 24) {
		return `${Math.round(differenceInHours)}h`;
	} else {
		return `${Math.round(differenceInDays)}d`;
	}
};
